// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DollarCircleIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "DollarCircle/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.625 13.267h.542c.541 0 .991-.484.991-1.067 0-.725-.258-.867-.683-1.017l-.842-.291v2.375h-.008Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.975 1.583c-4.6.017-8.325 3.759-8.308 8.359.016 4.6 3.758 8.325 8.358 8.308 4.6-.017 8.325-3.758 8.308-8.358-.016-4.6-3.758-8.317-8.358-8.309ZM11.883 10c.65.225 1.525.708 1.525 2.2 0 1.283-1.008 2.317-2.241 2.317h-.542V15a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-.483h-.3c-1.367 0-2.475-1.15-2.475-2.567a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625c0 .725.55 1.317 1.225 1.317h.3V10.45L8.117 10c-.65-.225-1.525-.708-1.525-2.2 0-1.283 1.008-2.317 2.241-2.317h.542V5A.63.63 0 0 1 10 4.375a.63.63 0 0 1 .625.625v.483h.3c1.367 0 2.475 1.15 2.475 2.567a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625c0-.725-.55-1.317-1.225-1.317h-.3V9.55l1.258.45Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.85 7.808c0 .725.258.867.683 1.017l.842.292V6.733h-.542c-.541 0-.983.484-.983 1.075Z"
}));
export default DollarCircleIcon;